module.exports = __webpack_public_path__ + "transfers_icon.svg?ddd7c206674e1f0a5535968dc88c44b3";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images/transfers_icon.svg
// module id = 1067
// module chunks = 15